<app-toastr></app-toastr>
<app-sweet-alert></app-sweet-alert>
<router-outlet></router-outlet>
